import { atom } from "recoil";
import { sessionStorageEffect } from "../../../../persistAtom";

// all_zoom_notification 데이터 상태 (배열)
export const zoomNotificationState = atom({
  key: "zoomNotificationState",
  default: [],
  effects: [sessionStorageEffect("zoomNotification")],
});

// 로딩 상태
export const zoomNotificationLoadingState = atom({
  key: "zoomNotificationLoadingState",
  default: false,
});

// 에러 상태
export const zoomNotificationErrorState = atom({
  key: "zoomNotificationErrorState",
  default: null,
});

// 초기화 완료 상태
export const zoomNotificationInitializedState = atom({
  key: "zoomNotificationInitializedState",
  default: false,
});
